import { render, staticRenderFns } from "./RecuperarSenhaForm.vue?vue&type=template&id=eb523fbc&"
import script from "./RecuperarSenhaForm.vue?vue&type=script&lang=js&"
export * from "./RecuperarSenhaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports